<template>


<div class="container">
	<div class="row">
		<div class="col-lg-8">
		<h1>Cloud commputing</h1>
		<small class="text-muted">
			Today  90% of all companies are the cloud which helps their application accessible everywhere, and all the time.
		</small>
<p class="lead">
There are many benefits as well as potential new business opportunities for companies using cloud technologies. While being on the cloud companies can scale resources according to user demand as well as expand into other geographic areas easily, they also can create services instead of the products, provide platforms for others to create new services, create infrastructures where others can host their services.
</p>
<p>
Cloud Computing is a network of data centres that provides you with almost unlimited computing and storage resources. Because of economies of scale, Cloud services became a cost-effective solution for many digital services.
</p>


	<div class="card mx-sm-4 my-4">
		<div class="card-body bg-secondary">
			<h5 class="card-title">5 biggest Cloud providers</h5>
			<p>
				<small>Global market shares</small>
				<ul>
					<li>Amazon AWS - 32% </li>
					<li>Microsoft Azure - 16%</li>
					<li>Google Cloud - 10%</li>
					<li>Alibaba Cloud - 4%</li>
					<li>IBM Cloud - 4%</li>
				</ul>
			</p>
		</div>
	</div>



<p>
Along with storage and computing resources, cloud providers offer a vast range of products and services to help customers implement ready-made solutions for common business challenges (such as data storage, data search, user management, analytics, messaging and other services).
</p>
<p>
Services and product offered by Cloud provider can be used as part of custom solutions in your applications. Also, they can be an example and inspiration for the services and product you could create and offer to your customers.
</p>
<p>
The main Cloud service models are:
</p>
<dl>
<dt>IaaS - Infrastructure as a Service</dt>
<tt>A virtual computing environment that can scale up or down automatically depending on the usage. It includes networking, computing and data storage resources as well as additional services. IaaS is designed to substitute or extend on-premises data-centres.</tt>
<dt>CaaS - Containers-as-a-service</dt>
<tt>An environment that allows users to manage and deploy containers, applications and clusters through container-based virtualization. As more companies offer their products as containerized applications this model is becoming very popular. </tt>
<dt>PaaS - Platform as a Service</dt>
<tt>The cloud platform is a prebuilt environment consisting of servers, data storages, networks, as well as various software products and services that allows users to deploy their applications without the need to manage the underlying system.</tt>
<dt>SaaS - Software as a Service</dt>
<tt>Applications which are accessible by the clients via either a web browser or some lightweight applications. Google’s apps (like Gmail, Google Drive, and Google Play) are a perfect example of SaaS. This by far the most popular Cloud model.</tt>
<dt>BPaaS - Business Process as a Service</dt>
<tt>Business process, such as payroll and benefits administration, procurement, advertising, marketing and industry operation processes, outsourcing to automated cloud-based service.</tt>
</dl>

		</div>
		<div class="col-lg-4">


			<div class="card my-5">
				<div class="card-body bg-dark text-secondary">
					<h5 class="card-title text-secondary">Smart technologies</h5>
					<p class="card-text">
						Enhance your products and services, improve your customer experience by introducing AI, Deep Learning, Genetic Algorithms in your projects.
					</p>
					<a href="#/artificial_intelligence" class="btn btn-outline-white">More info</a>
				</div>
			</div>

		</div>
	</div>
</div>


</template>

<script>
export default {
	data() {
		return {
			metadata: {
				section: "technology",
				title: "Cloud Computing"
			}
		}
	},
	methods: {
		loadToParent: function() {
			this.$emit("data-to-parent", this.metadata);
		}
	},
	mounted: function() {
		this.loadToParent();	
	},
}
</script>
